<rt-box variant="background vertical no-padding with-header" margin-bottom-small>
  @if (header) {
    <div class="box-header" padding-small>
      <rt-heading class="subheading uppercased">
        {{ header }}
      </rt-heading>
    </div>
  }

  @if (itemsVisible) {
    <ul class="items" padding-lr-small>
      @for (item of items; track trackByItem($index, item)) {
        <li class="item" text-weight-semi-bold>
          <rt-icon name="check" size="medium" margin-right-small></rt-icon>
          {{ buildText(item) }}
        </li>
      }
    </ul>
  }
</rt-box>
